import { render } from "./AliasFields.vue?vue&type=template&id=3d62121a&ts=true"
import script from "./AliasFields.vue?vue&type=script&lang=ts"
export * from "./AliasFields.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__